<h2>{{ 'events.dashboard.component.title' | translate | titlecase }}</h2>

<form (submit)="handleSearchSubmit($event)">
  <div class="form-horizontal">
    <div class="form-group">
      <div class="col-sm-12">
        <span class="wl-give-calendar-right-padding date-selector-container">
          <wl-date-selector name="searchDateBegin" [(ngModel)]="searchParams.SearchDateBegin"></wl-date-selector>
          <wl-date-selector name="searchDateEnd" [(ngModel)]="searchParams.SearchDateEnd"></wl-date-selector>
        </span>
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-3">
        <select class="form-control" name="eventType" [(ngModel)]="searchParams.EventType">
          <option [value]="null">-- {{ 'events.dashboard.component.event-type-label' | translate | titlecase }} --</option>
          <option *ngFor="let eventType of _eventTypes" [value]="eventType">
            {{ searchParams.EventType == eventType ? ('events.dashboard.component.event-type-label' | translate | titlecase) + ': ' : ''
            }}{{ eventType }}
          </option>
        </select>
      </div>
      <div class="col-md-9">
        <label class="checkbox-inline">
          <input type="checkbox" name="orgEvent" [(ngModel)]="searchParams.OrganizationEvent" />
          {{ 'events.dashboard.component.restrict-to-organization-label' | translate }}
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" name="communityEvent" [(ngModel)]="searchParams.CommunityEvent" />
          {{ 'events.dashboard.component.restrict-to-community-label' | translate }}
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" name="membersOnlyEvent" [(ngModel)]="searchParams.MembersOnlyEvent" />
          {{ 'events.dashboard.component.restrict-to-members-only-label' | translate }}
        </label>
        <label class="checkbox-inline">
          <input type="checkbox" name="internalEvent" [(ngModel)]="searchParams.InternalEvent" />
          {{ 'events.dashboard.component.restrict-to-internal-label' | translate }}
        </label>
      </div>
    </div>
    <p>
      <label>
        <input type="checkbox" name="withPendingRegistrations" [(ngModel)]="searchParams.EventsWithPendingRegistrationsOnly" />
        {{ 'events.dashboard.component.restrict-to-events-with-pending-registrations-label' | translate }}
      </label>
    </p>
    <p>
      <button pButton type="submit" class="btn btn-default" [disabled]="isSearching" [icon]="!isSearching ? 'pi pi-search' : ''">
        <span [hidden]="isSearching">
          {{ 'common.search' | translate | titlecase }}
        </span>
        <span [hidden]="!isSearching">
          <wl-busy [show]="isSearching"></wl-busy>
          {{ 'common.searching' | translate | titlecase }}
        </span>
      </button>
      <a href="#" (click)="$event.preventDefault(); export()" [class.disabled]="_exporting">{{
        'events.dashboard.component.export-text' | translate | titlecase
      }}</a>
      <wl-busy [show]="_exporting"></wl-busy>
      <span class="text-danger" [hidden]="!_exportEmpty">{{ 'events.dashboard.component.export-empty' | translate | ucfirst }}</span>
    </p>
    <div class="alert alert-danger" [hidden]="!_error">{{ _error }}</div>
  </div>
</form>
<div class="event-list wc-with-cards wc-with-prime-list">
  <div [wl-busy-overlay]="isSearching">
    <p-dataView
      #upcomingEventsDataGrid
      [lazy]="true"
      [rows]="10"
      [value]="upcomingEvents.Result"
      [paginator]="true"
      [paginatorPosition]="'both'"
      (onLazyLoad)="lazyLoad($event)"
      [totalRecords]="upcomingEvents.TotalCount"
      layout="grid"
    >
      <ng-template let-events pTemplate="gridItem">
        <div class="card" *ngFor="let event of events">
          <div class="card-block">
            <div class="wc-card-controls pull-right">
              <a href="#" (click)="$event.preventDefault(); gotoEvent(event.EventId)">{{ event?.EventId }}</a>
            </div>
            <h4 class="card-title">
              <a [routerLink]="['/event/' + event.EventId?.toString()]">{{ event.EventName }}</a>
            </h4>
            <p class="card-text">
              {{ event.StartDateTimeUtc | date: 'M/d/yyyy' }} {{ event.StartTime }}
              <span
                [hidden]="
                  (event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy') &&
                  event.StartTime == event.EndTime
                "
                >-
                <span [hidden]="(event.StartDateTimeUtc | date: 'M/d/yyyy') == (event.EndDateTimeUtc | date: 'M/d/yyyy')">{{
                  event.EndDateTimeUtc | date: 'M/d/yyyy'
                }}</span>
                {{ event.EndTime }}</span
              >
            </p>
            <p class="card-text">
              <span
                class="wc-event-badge"
                title="Organization Event"
                [ngClass]="{ 'bg-org-event': event.OrgEvent, 'bg-event-type-off': !event.OrgEvent }"
                >O</span
              >
              <span
                class="wc-event-badge"
                title="Community Event"
                [ngClass]="{ 'bg-community-event': event.IsPublic, 'bg-event-type-off': !event.IsPublic }"
                >C</span
              >
              <span
                class="wc-event-badge"
                title="Members Only Event"
                [ngClass]="{ 'bg-member-event': event.MembersOnly, 'bg-event-type-off': !event.MembersOnly }"
                >M</span
              >
              <span
                class="wc-event-badge"
                title="Internal Event"
                [ngClass]="{ 'bg-internal-event': event.Internal, 'bg-event-type-off': !event.Internal }"
                >I</span
              >
            </p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              {{ 'events.dashboard.component.total-attendees-label' | translate | titlecase }}:<span class="badge pull-right">{{
                event.PotentialAttendees
              }}</span>
            </li>
            <li class="list-group-item">
              {{ 'events.dashboard.component.pending-registrations-label' | translate | titlecase }}:<span class="badge pull-right">{{
                event.PendingRegistrations
              }}</span>
            </li>
            <li class="list-group-item">
              {{ 'events.dashboard.component.total-invoiced-label' | translate | titlecase }}:<span class="badge pull-right">{{
                event.TotalInvoiced | currency
              }}</span>
            </li>
          </ul>
        </div>
      </ng-template>
    </p-dataView>
  </div>
</div>
<wl-events-new #newEventDialog> </wl-events-new>
